$(document).ready(function() {
       setTimeout(function() {
            $('#mob-recommand-slider').owlCarousel({
		loop: true,
		margin: 30,
		autoplay: false,
        autoplayTimeout: 2000,
		dots: false,
		responsiveClass: true,
		responsive: {
		  0: {
			items: 1.5,
			nav: false
		  },
		  600: {
			items: 1.5,
			nav: false
		  },
		  1000: {
			items: 2.5,
			nav: true,
			margin: 40
		  }
		}
	})
          }, 2000);
})


$(document).ready(function() {
     
            $('.mob-recommand-slider-home').owlCarousel({
		loop: true,
		margin: 25,
		autoplay: false,
        autoplayTimeout: 2000,
		dots: false,
		responsiveClass: true,
		responsive: {
		  0: {
			items: 1.5,
			nav: false
		  },
		  600: {
			items: 1.5,
			nav: false
		  },
		  1000: {
			items: 3,
            margin: 0,
			nav: true
			
		  }
		}
	})
      
})

  $('.open-modal-open').on('click', function() { 
     $('body').toggleClass('menu-open');
     $('.convideo-home').trigger('play');

  });
 $(".btn-close").click(function(){
	$(".toggle-wrap").trigger('click');
     $('.convideo-home').trigger('pause');
	});
// setTimeout(function() {
// $('.tab-icon').on('click', function() {
//   $('body').addClass('changeCursor');
// });
// $('.coupon-tab-close').on('click', function() {
//   $('body').removeClass('changeCursor');
// });
// },2000);

setTimeout(function() {
if($(".eapp-age-verification-popup-container").hasClass("eapp-age-verification-popup-show"))
   {
      $('body').addClass('changeCursor');
   }
   $('.eapp-age-verification-item-allow-buttons-yes').click(function(){
         $('body').removeClass('changeCursor');
    });
    $('.tab-icon').on('click', function() {
       $('body').addClass('changeCursor');
      });
     $('.coupon-tab-close').on('click', function() {
      $('body').removeClass('changeCursor');
      });
  },3000);

 $('.coupon-tab-close').on('click', function() {
      $('body').removeClass('changeCursor');
      });

